import { useHistory } from "react-router-dom";

export function useSearchParam(paramName: string): string {
  const history = useHistory();
  const params: any = new URLSearchParams(history.location.search);
  return params.get(paramName);
}
